export enum SubscribersTotal {
    Previous = "Previous",
    Current = "Current",
}
